<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          today
        </mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.events' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->
    </div>
    <!-- / HEADER -->


    <!-- CONTENT -->
    <div class="content-card mat-white-bg">
      <mat-table class="products-table"
        #table [dataSource]="events"
        id="recommendEvent"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="title">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="title">{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event" class="title" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
            <p class="text-truncate">{{event.title}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="organization" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="organization">{{'main.organization' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event" class="organization" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
            <p class="text-truncate">{{event.organization.name}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="reserveCount" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="reserve-count">{{'main.reserveCount' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event" class="reserve-count" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
            <p class="text-truncate">{{event.reserveCount}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="date">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.event_start' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
            <p   matTooltip="{{event.dateForShow}}" class="text-truncate">{{event.dateForShow}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="type">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="organization-type">{{'organization.organizationType' | translate}}
          </mat-header-cell>
          <mat-cell *cdkCellDef="let event" class="organization-type" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
            <p class="text-truncate" [ngStyle]="{'border-bottom' : '2px solid ' + event.eventType.color}"><span
            [ngStyle]="{'background-color' : event.eventType.color}"></span>{{event.eventType.name}}
          </p>
        </mat-cell>
      </ng-container>

      <ng-container cdkColumnDef="recommended">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header [ngClass]="'icons'">{{'event.recommended' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let event" [ngClass]="'icons'" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
          @if (event.recommendation.length) {
            <mat-icon class="green recommended">check</mat-icon>
          }
          @if (!event?.recommendation?.length) {
            <mat-icon class="red recommended">close</mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container cdkColumnDef="recommendedBy">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header class="recommended-by">{{'event.recommended_by' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let event" class="recommended-by" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
          @if (event.recommendation.length) {
            <p class="text-truncate">{{event?.recommendation[0]?.user?.firstName + ' ' + event?.recommendation[0]?.user?.lastName}}</p>
          }
        </mat-cell>
      </ng-container>

      <ng-container cdkColumnDef="recommendationText">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header class="recommendation-text-cell">{{'event.recommendation_text' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let event" class="recommendation-text recommendation-text-cell">
          @if (event.recommendation.length) {
            <p class="text-truncate" [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}"
            matTooltip="{{event?.recommendation[0]?.recommendation_text}}">{{event?.recommendation[0]?.recommendation_text}}</p>
          }
          @if (event.recommendation.length && +userId === +event.recommendation[0].userId) {
            <mat-icon
              (click)="editRecommendation($event, event)"
            matTooltip="{{'event.edit_recommendation_text' | translate}}">edit</mat-icon>
          }

          @if (event.recommendation.length && +userId !== +event.recommendation[0].userId) {
            <mat-icon
              (click)="editRecommendation($event, event, true)"
            matTooltip="{{'event.recommendation_text_preview' | translate}}">visibility</mat-icon>
          }
        </mat-cell>
      </ng-container>


      <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>


      <mat-row *cdkRowDef="let event; columns: displayedColumns;"
        class="product"
        matRipple>
      </mat-row>

    </mat-table>
    @if (events.length === 0) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{'main.noData' | translate}}</span>
      </div>
    }
    <mat-paginator #paginator
      [length]="eventsLength"
      [pageIndex]="_pageIndex"
      [pageSize]="_perPage"
      [pageSizeOptions]="[10, 25, 50, 100]"
      (page)="changePageEmitter($event)">
    </mat-paginator>

  </div>
  <!-- / CONTENT -->

</div>
</div>



